<template>
    <div class="assembly">
         <div class="m-left"><span></span> 选择组件</div>
         <div class="select">
            <div :class="['select-item',{'active':selectIndex == index}]" v-for="(item,index) in selectList" :key="index"  @click="selectIndex = index">
                <div class="item-img">
                    <img :src="item.url" alt="" draggable="true" @dragend="dragend_fn($event,index)">
                </div>
                <p>{{item.name}}</p>
            </div>

         </div>
        <div class="m-left"><span></span> 编辑属性</div>
        
        <div class="style-con" v-show="selectIndex == 0">
              <div class="tab-chat">
                <div><span v-for="(item,index) in tabList" :key="index" :class="[{'active':tabIndex == index}]" @click="tabIndex = index">{{item}}</span></div>
                 <p>预览</p>
            </div>
            <div v-show="tabIndex == 0">
                <div class="style-item">
                        <span>标题名称</span>
                    <el-input  v-model="titleName" placeholder="请输入标题名称"  @input="singleChange_fn" style="width:240px"> </el-input>
                </div>
                <div class="style-item">
                            <span>标题样式</span>
                            <el-select v-model="titleIcon" filterable clearable placeholder="请选择" style="width:100px;margin-right:12px" @change="singleChange_fn">
                                <el-option
                                v-for="item in fontSizeList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                            <el-color-picker v-model="titleColor" show-alpha @change="singleChange_fn"></el-color-picker>
                </div>
                <div class="style-item">
                            <span>标题背景</span>
                            <el-color-picker v-model="titleBgColor" show-alpha @change="singleChange_fn"></el-color-picker>
                </div>
                <div class="style-item">
                            <span>查询时间</span>
                        <el-select v-model="timeVal" filterable clearable placeholder="请选择" @change="singleChange_fn" style="width:240px">
                                <el-option
                                v-for="item in timeOptions"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                </div>
                <div class="style-item">
                            <span>查询类型</span>
                            <el-select v-model="titleType" filterable clearable placeholder="请选择" @change="singleChange_fn" style="width:240px">
                                <el-option
                                v-for="item in nameOptions"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                </div>
                <div class="style-item">
                            <span>单值样式</span>
                            <el-select v-model="valIcon" filterable clearable placeholder="请选择" style="width:100px;margin-right:12px" @change="singleChange_fn">
                                <el-option
                                v-for="item in fontSizeList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                            <el-color-picker v-model="valColor" show-alpha @change="singleChange_fn"></el-color-picker>
                </div>
                <div class="style-item">
                            <span>单值背景</span>
                            <el-color-picker v-model="valBgColor" show-alpha @change="singleChange_fn"></el-color-picker>
                </div>
                <div class="style-item">
                            <span>模块边框</span>
                            <el-color-picker v-model="modelColor" show-alpha @change="singleChange_fn"></el-color-picker>
                </div>
            </div>

              <div v-show="tabIndex == 1" class="line-data-y">
                <div class="direct">
                        <div class="data-type">
                            <span>应用类型：</span>
                            <el-select v-model="screenTypevalue" clearable placeholder="选择应用类型" >
								<el-option v-for="item in screenTypeData" :key="item.id" :label="item.name" :value="item.id"></el-option>
							</el-select>
                        </div>
                          <div class="variable-tree" :style="{'height':heights+'px'}">
                            <el-scrollbar style="height:100%;width: 100%;">
                                <el-tree
                                        class="filter-tree"
                                        :data="treeList"
                                        :props="defaultProps2"
                                        ref="tree"
                                       >
                                        <span class="custom-tree-node" slot-scope="{node}" >
                                             <div v-if="routeData.kanBanType == '指定'">
                                                <img src="../../../public/static/image/elTree/1.9.png" style="margin-right: 2px;" 
                                                    v-if="node.data.Content.Category && node.data.Content.Category == 'Organization'"/>

                                                    <img src="../../../public/static/image/elTree/variable.png" style="margin-right: 2px;" 
                                                    v-if="node.data.Content.variableName"/>

                                                    <img src="../../../public/static/image/elTree/2.1.png" style="margin-right: 2px; position: relative;top: 1px;" 
                                                    v-if="node.data.Content.Category &&  node.data.Content.Category == 'Device'"/>
                                             </div>
                                             <div v-if="routeData.kanBanType == '通用'">
                                                  <img src="../../../public/static/image/elTree/variable.png" style="margin-right: 2px;" 
                                                    v-if="node.data.Content.Category == 'AppType'"/>

                                                    <img src="../../../public/static/image/elTree/2.1.png" style="margin-right: 2px; position: relative;top: 1px;" 
                                                    v-if="node.data.Content.Category == 'AppTypeGroup'"/>
                                             </div>
                                             <span style="padding-left: 5px;" >{{node.data.Content.Name}}</span>
                                        </span>
                                         
                                        
                                </el-tree>
                                 <!-- 看板类型为通用 -->
                            </el-scrollbar>
                          
                        </div>
                 </div>
             </div>
        </div>
        <!-- 复合单值 -->
         <div class="style-con" v-show="selectIndex == 1">
            <div class="tab-chat">
                <div><span v-for="(item,index) in tabList" :key="index" :class="[{'active':tabIndex == index}]" @click="tabIndex = index">{{item}}</span></div>
                 <p @click="previewData_fn">预览</p>
            </div>
       
             <div v-show="tabIndex == 0">
                  <div class="style-item">
                    <span>查询时间</span>
                   <el-select v-model="futimeVal" filterable  placeholder="请选择" @change="fusingleChange" style="width:240px">
                        <el-option
                        v-for="item in timeOptionsss"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
         </div>
       
        <div class="style-item">
                    <span>环比标题</span>
                     <el-input-number v-model="huanSpacing" controls-position="right"  :min="1" :max="2000" style="wdith:120px" @change="fusingleChange"></el-input-number>(间距)
                    <el-select v-model="huanFont" filterable  placeholder="请选择" style="width:100px;margin-left:12px" @change="fusingleChange">
                        <el-option
                        v-for="item in fontSizeList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>(字号)
                    <el-color-picker v-model="huanColor" show-alpha @change="fusingleChange" style="margin-left:12px"></el-color-picker>
        </div>
          <div class="style-item">
                    <span>环比单值</span>
                    <el-select v-model="huanValFont" filterable  placeholder="请选择" style="width:100px;" @change="fusingleChange">
                        <el-option
                        v-for="item in fontSizeList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>(字号)
                    <!-- <el-color-picker v-model="huanValColor" show-alpha @change="fusingleChange"></el-color-picker> -->
        </div>
          <div class="style-item">
                    <span>同比标题</span>
                     <el-input-number v-model="tongSpacing" controls-position="right"  :min="1" :max="2000" style="wdith:120px" @change="fusingleChange"></el-input-number>(间距)
                    <el-select v-model="tongFont" filterable  placeholder="请选择" style="width:100px;margin-left:12px" @change="fusingleChange">
                        <el-option
                        v-for="item in fontSizeList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>(字号)
                    <el-color-picker v-model="tongColor" show-alpha @change="fusingleChange" style="margin-left:12px"></el-color-picker>
        </div>
          <div class="style-item">
                    <span>同比单值</span>
                    <el-select v-model="tongValFont" filterable  placeholder="请选择" style="width:100px;" @change="fusingleChange">
                        <el-option
                        v-for="item in fontSizeList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>(字号)
                    <!-- <el-color-picker v-model="tongValColor" show-alpha @change="fusingleChange"></el-color-picker> -->
        </div>
           <div class="style-item">
                    <span>原值标题</span>
                     <el-input-number v-model="yuanSpacing" controls-position="right"  :min="1" :max="2000" style="wdith:120px" @change="fusingleChange"></el-input-number>(间距)
                    <el-select v-model="yuanFont" filterable  placeholder="请选择" style="width:100px;margin-left:12px" @change="fusingleChange">
                        <el-option
                        v-for="item in fontSizeList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>(字号)
                    <el-color-picker v-model="yuanColor" show-alpha @change="fusingleChange" style="margin-left:12px"></el-color-picker>
        </div>
          <div class="style-item">
                    <span>原值单值</span>
                    <el-select v-model="yuanValFont" filterable  placeholder="请选择" style="width:100px;" @change="fusingleChange">
                        <el-option
                        v-for="item in fontSizeList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>(字号)
                    <el-color-picker v-model="yuanValColor" show-alpha @change="fusingleChange" style="margin:0px 12px"></el-color-picker>
                    <el-switch v-model="switchVal" @change="fusingleChange"></el-switch> {{switchVal ? '显示' : '隐藏'}}
        </div>
             </div>
             <div v-show="tabIndex == 1" class="line-data-y">
                <div class="direct">
                        <div class="data-type">
                            <span>应用类型：</span>
                            <el-select v-model="screenTypevalue" placeholder="选择应用类型" >
								<el-option v-for="item in screenTypeData" :key="item.id" :label="item.name" :value="item.id"></el-option>
							</el-select>
                        </div>
                          <div class="variable-tree" :style="{'height':heights+'px'}">
                            <el-scrollbar style="height:100%;width: 100%;">
                                <el-tree
                                        class="filter-tree"
                                        :data="treeList"
                                        show-checkbox
                                        :props="defaultProps2"
                                        node-key="keyId"
                                        @check="currentChecked"
                                        ref="tree"
                                       >
                                        <span class="custom-tree-node" slot-scope="{node}" >
                                             <div v-if="routeData.kanBanType == '指定'">
                                                <img src="../../../public/static/image/elTree/1.9.png" style="margin-right: 2px;" 
                                                    v-if="node.data.Content.Category && node.data.Content.Category == 'Organization'"/>

                                                    <img src="../../../public/static/image/elTree/variable.png" style="margin-right: 2px;" 
                                                    v-if="node.data.Content.variableName"/>

                                                    <img src="../../../public/static/image/elTree/2.1.png" style="margin-right: 2px; position: relative;top: 1px;" 
                                                    v-if="node.data.Content.Category &&  node.data.Content.Category == 'Device'"/>
                                             </div>
                                             <div v-if="routeData.kanBanType == '通用'">
                                                  <img src="../../../public/static/image/elTree/variable.png" style="margin-right: 2px;" 
                                                    v-if="node.data.Content.Category == 'AppType'"/>

                                                    <img src="../../../public/static/image/elTree/2.1.png" style="margin-right: 2px; position: relative;top: 1px;" 
                                                    v-if="node.data.Content.Category == 'AppTypeGroup'"/>
                                             </div>
                                             <span style="padding-left: 5px;" >{{node.data.Content.Name}}</span>
                                        </span>
                                         
                                        
                                </el-tree>
                                 <!-- 看板类型为通用 -->
                            </el-scrollbar>
                          
                        </div>
                 </div>
             </div>
        
       
        
        
        </div>



       
        
       
        
        
    </div>
</template>

<script>
import {previewData} from "../../api/customKanBanApi";
export default {
    // props:['nowSingleData','routeData'],
    props: {
        //  routeData: {
        //     type: Object,
        //     default: () => ({})
        // },
         nowSingleData: {
            type: Object,
            default: () => ({})
        },
      
        
        },
    data() {
        return {
            routeData:[],
            widthNum:80,
            //组件数据
             selectList:[
                {
                  'name':"基础单值",
                  'url':require('@/assets/customKanBan/kanBanChart/danzhi.png'),
                },
                {
                  'name':"复合单值",
                  'url':require('@/assets/customKanBan/kanBanChart/compositeSing.png'),
                },
                ],
            //选项卡
            tabList:['样式','数据'],
            selectIndex:0,
            tabIndex:0,
            value:false,
            titleType:"",
            timeOptions: [{
            value: '今日',
            label: '今日'
            }, {
            value: '昨日',
            label: '昨日'
            }, {
            value: '当月',
            label: '当月'
            }, {
            value: '上月',
            label: '上月'
            }, {
            value: '当年',
            label: '当年'
            }, {
            value: '今年',
            label: '今年'
            }, {
            value: '上年',
            label: '上年'
            }],
            nameOptions:[
                {
                value: '负荷',
                label: '负荷'
                },
                {
                value: '能耗',
                label: '能耗'
                },
                {
                value: '需量',
                label: '需量'
                },
            ],
            value1: '',
             fontSizeList:[],
             
             timeVal:"",//时间
            titleName:"",
            titleIcon:"14",
            titleColor:"#fff",
            titleBgColor:"#2DA6EB",
            valIcon:"14",
            valColor:"#ff9900",
            valBgColor:"#21577d",
             modelColor:'#626dca',
            //  复合单值
            timeOptionsss:[
                {
                value: 'DAY',
                label: '日'
                }, {
                value: 'MON',
                label: '月'
                }
            ],
            futimeVal:"MON",//时间
            
            huanSpacing:10,//环比间距
            huanFont:"14px",//字号
            huanValFont:"14px",//环比值字号
            huanColor:"#fff", //环比标题颜色
            huanValColor:"#fff",
            tongSpacing:10,//同比间距
            tongFont:"14px",
            tongValFont:"14px",
            tongColor:"#fff",
            tongValColor:"#fff",
            yuanSpacing:10,
            yuanFont:"14px",
            yuanValFont:"14px",
            yuanColor:"#fff",
            yuanValColor:'#fff',
            switchVal:true,

             //变量类型
             screenTypeData:[],
			 screenTypevalue:"",
             //设备变量树形结构
			treeList: [],
            treeListCopy:[],
            heights: document.getElementById('app').clientHeight-560,
            //变量树形图
            defaultProps2: {
					children: 'ChildDatas',
					label: 'Content.Name'
				},
                checkedNodes:[],
                originalValue:20,//原值
                lastCompareValue:20,//同比
                sameCompareValue:20,//环比
                arrIndex:-1,

        };
    },

    mounted() {
        for(let i = 14 ;i<=20;i++){
           if(i % 2 ==0){
              this.fontSizeList.push({
                label:i,
                value:i + 'px'
              })
           }
       }
       this.routeData = this.$store.deviceStore.state.customKanBanList
      
    },
    watch:{
          //看板类型
        routeData(val){
             this.treeList = val
             this.treeListCopy = JSON.parse(JSON.stringify(this.treeList))
             this.screenTypeData = this.$store.deviceStore.state.kanBanAppTypeGroup
        },
      nowSingleData(val){
        if(JSON.stringify(val) == '{}'){
            this.arrIndex = -1
             this.$refs.tree.setCheckedKeys([]);
            return
          }
         var datList = JSON.parse(JSON.stringify(val))
         this.selectIndex = datList.type
         this.arrIndex =  datList.arrIndex
        
        if(datList.type == 0){
             this.timeVal = datList.timeVal
            this.titleName = datList.titleName
            this.titleType = datList.titleType
            this.titleIcon = datList.titleIcon
            this.titleColor = datList.titleColor
            this.titleBgColor = datList.titleBgColor
            this.valColor = datList.valColor
            this.valIcon = datList.valIcon
            this.valBgColor = datList.valBgColor
            this.modelColor = datList.modelColor
        }else {
               if(JSON.stringify(datList.resParameter) == '{}'){
                  this.$refs.tree.setCheckedKeys([]);
               }else {
                  this.$refs.tree.setCheckedNodes(datList.resParameter.resParameter[0].checkedNodes);
               }
              this.futimeVal = datList.timeVal
              this.switchVal = datList.switchVal
              this.huanSpacing = (datList.hangStyle.marginRight).replace(/px/g, "")
              this.huanColor = datList.hangStyle.color
              this.huanFont = datList.hangStyle.fontSize

              this.tongSpacing = (datList.tongStyle.marginRight).replace(/px/g, "")
              this.tongFont = datList.tongStyle.fontSize
              this.tongColor = datList.tongStyle.color

              this.yuanSpacing = (datList.yuanStyle.marginRight).replace(/px/g, "")
              this.yuanFont = datList.yuanStyle.fontSize
              this.yuanColor = datList.yuanStyle.color


              this.huanValFont = datList.huanValStyle.fontSize
              this.tongValFont = datList.tongValStyle.fontSize
              this.yuanValFont = datList.yuanValStyle.fontSize
              this.yuanValColor = datList.yuanValStyle.color
            
        }
      },
      
        //筛选类型
		screenTypevalue(val){
			this.screenType_fn(val)
				// this.$refs.tree.filter(val);
		},
        
    },

    methods: {
        //拖放
        dragend_fn(e,index){
           var clientX = e.clientX
            var clientY = e.clientY
            var d  = {}
            this.selectIndex  = index
             
            if(index == 0){
                d  = {
                 'clientX':clientX, 
                 'clientY':clientY,
                 'tabIndex':4,
                 "timeVal":this.timeVal,
                 "titleName":this.titleName,
                 "titleType":this.titleType,
                "titleIcon":this.titleIcon,
                "titleColor":this.titleColor,
                "titleBgColor":this.titleBgColor,
                "valIcon":this.valIcon,
                "valColor":this.valColor,
                "valBgColor":this.valBgColor,
                 'modelColor':this.modelColor,
                 'type':index,
                 'resParameter':{}
            }
            }else {
                 d  = {
                     'clientX':clientX, 
                    'clientY':clientY,
                    'tabIndex':4,
                     'type':index,
                     "timeVal":this.futimeVal,
                    
                    "hangStyle":{ //环比
                       "marginRight":this.huanSpacing+'px', //间距
                        "fontSize":this.huanFont, //字号
                        'color':this.huanColor,
                    },
                    'hangXY':{
                        'top':'35px',
                        'left':'30px',
                    },
                    "huanValStyle":{ //环比值
                        "fontSize":this.huanValFont, 
                    },
                    "tongStyle":{ //环比
                       "marginRight":this.tongSpacing+'px', //间距
                        "fontSize":this.tongFont, //字号
                        'color':this.tongColor,
                    },
                    "tongValStyle":{ //同比值
                        "fontSize":this.tongValFont, 
                    },
                    'tongXY':{
                        'top':'65px',
                        'left':'30px',
                    },
                    //原值
                    'yuanXY':{
                        'top':'5px',
                        'left':'58px',
                    },
                    "yuanStyle":{
                        "marginRight":this.yuanSpacing+'px', //间距
                        "fontSize":this.yuanFont, //字号
                        'color':this.yuanColor,
                    },
                    "yuanValStyle":{ //原值
                        "fontSize":this.yuanValFont, 
                        'color':this.yuanValColor
                    },
                    "originalValue":this.originalValue,//原值
                    "lastCompareValue":this.lastCompareValue, //环比
                    "sameCompareValue":this.sameCompareValue,//同比
                    'switchVal':this.switchVal,//是否显示单值
                    'resParameter':{}
                }
            }
           
             this.$emit('single_fn',d)
        },
        //单值改变
        singleChange_fn(){
            if(JSON.stringify(this.nowSingleData) != '{}'){
                var d  = {
                    "timeVal":this.timeVal,
                        "titleName":this.titleName,
                        "titleType":this.titleType,
                        "titleIcon":this.titleIcon,
                        "titleColor":this.titleColor,
                        "titleBgColor":this.titleBgColor,
                        "valIcon":this.valIcon,
                        "valColor":this.valColor,
                        "valBgColor":this.valBgColor,
                        'modelColor':this.modelColor  
                }
                this.$emit('changSingle_fn',d)
            }
           


        },
        //复合单值
        fusingleChange(data){
             
            var d  = {
                    "timeVal":this.futimeVal,
                    "hangStyle":{ //环比
                       "marginRight":this.huanSpacing+'px', //间距
                        "fontSize":this.huanFont, //字号
                        'color':this.huanColor,
                    },
                    
                    "huanValStyle":{ //环比值
                        "fontSize":this.huanValFont, 
                    },
                    "tongStyle":{ //环比
                       "marginRight":this.tongSpacing+'px', //间距
                        "fontSize":this.tongFont, //字号
                        'color':this.tongColor,
                    },
                    "tongValStyle":{ //同比值
                        "fontSize":this.tongValFont, 
                    },
                    
                    //原值
                    
                    "yuanStyle":{
                        "marginRight":this.yuanSpacing+'px', //间距
                        "fontSize":this.yuanFont, //字号
                        'color':this.yuanColor,
                    },
                    "yuanValStyle":{ //原值
                        "fontSize":this.yuanValFont, 
                        'color':this.yuanValColor
                    },
                    "originalValue":this.originalValue,//原值
                    "lastCompareValue":this.lastCompareValue, //环比
                    "sameCompareValue":this.sameCompareValue,//同比
                    'switchVal':this.switchVal,
                     'resParameter':data//请求参数
                    // 'checkedNodes':this.checkedNodes,
                    // 'handleArr':viArr
            }
            this.$emit('fusingleChange_fn',d)
        },

         //树形结构选中节点
			 currentChecked (nodeObj, SelectedObj) {
                
				this.checkedNodes = SelectedObj.checkedNodes

                if(this.routeData[0].kanBanType == '指定'){
                        this.checkedNodes.forEach((item,index) => {
                            if(!item.Content.hasOwnProperty('variableName')){
                                this.checkedNodes.splice(index,1)
                            }
                        })
                        this.checkedNodes.forEach((item,index) => {
                            if(item.hasOwnProperty('ChildDatas')){
                                this.checkedNodes.splice(index,1)
                            }
                        })
                 }else {
                      this.checkedNodes.forEach((item,index) => {
                            if(item.Content.Category == "AppTypeGroup"){
                                this.checkedNodes.splice(index,1)
                            }
                        })
                 }

            //    if(this.arrIndex != -1){
            //       this.fusingleChange()
            //    }
               
				

                // console.log("checkedNodes",this.checkedNodes);
                // console.log("halfCheckedNodes",this.halfCheckedNodes);

				
            },

         //类型筛选
            screenType_fn(value){
                    var a = JSON.parse(JSON.stringify(this.treeListCopy))
                    console.log("this.treeListCopy",this.treeListCopy);
                    if(value == ""){
                        this.treeList  = a 
                        return
                    }
                    if(this.routeData[0].kanBanType == '指定'){
                        var recursiveFunction = function(){
                                    const getStr = function(list){
                                        list.forEach(function(row){
                                            if(row.Content.Category == "Device"){
                                            row.ChildDatas = 	row.ChildDatas.filter(v => v.Content.Id == value)
                                            }else {
                                                if(row.ChildDatas == null){
                                                    row.ChildDatas = []
                                                }
                                                    getStr(row.ChildDatas)
                                            }
                                        })
                                    }
                                    getStr(a)
                                }
                            recursiveFunction()
                            this.treeList = a
                    }else {
                        var newArr =  a.filter(item => item.Content.id == value)
                        this.treeList = newArr
                    }
                    
                    
                },
        //点击预览
        previewData_fn(){
            if(this.arrIndex == -1){
                return
            }
            console.log("this.routeData",this.routeData);
            var viArr = []
            this.checkedNodes.forEach(item => {
                viArr.push({
                    'dateType':this.futimeVal,
                    'variableName':this.routeData[0].kanBanType =='指定' ? item.Content.variableName :  item.Content.Name,
                    'appType':item.Content.appType,
                })
            })
            var d = {
                "biType": this.routeData[0].kanBanType =='指定' ? 'CUSTOMIZED' :  'UNIVERSAL',
                "resParameter": [
                    {
                        "biCategory": "SINGLE_ASSORTED",
                        "resJsonPars": JSON.stringify(viArr),
                        'checkedNodes':this.checkedNodes,
                        "tag": `SINGLE_ASSORTED${this.arrIndex + 1}`
                    }
                ],
                "resType": 0,
                "unitId": this.routeData[0].Content.UnitId
            }
            console.log("参数",d);
            previewData(d).then(res => {
                console.log("返回的结果",res);
                if(res.code == 200){
                    this.originalValue  = res.data.biViews[0].data.originalValue
                    this.lastCompareValue  = res.data.biViews[0].data.lastCompareValue
                    this.sameCompareValue = res.data.biViews[0].data.sameCompareValue
                    this.fusingleChange(d)
                    this.$message({ showClose: true, message: '预览成功', type: 'success'})
                }else {
                    res.message ?  this.$message({ showClose: true, message:  res.message, type: 'warning'}) : this.$message({ showClose: true, message: '预览失败', type: 'warning'})
                }

            })
        },


      
        
       
    },
};
</script>

<style lang="scss" scoped>
.assembly{
        width: 100%;
    .m-left {
        color: #359EFF;
        display: flex;
        align-items: center;
        span {
            background-color: #359EFF;
            display: inline-block;
            width: 2px;
            height: 12px;
            margin-right: 4px;

        }
    }
    .select {
       display: flex;
       flex-wrap: wrap;
    // justify-content: space-between;
       margin-bottom: 40px;
        .select-item {
            width: 31%;
            height: 100px;
            margin-right: 20px;
            background-color: #000000;
            margin-top: 15px;
            display: flex;
            justify-content: center;
            flex-wrap: wrap;
             transition: all 0.3s;
            border: 2px solid transparent;
            .item-img {
                width: 95%;
                height: 68px;
                margin-top: 5px;
                display: flex;
                align-items: center;
                justify-content: center;
                img {
                    max-width: 95%;
                }

            }
            &.active {
                // border: 2px solid #0085FF;
                border: 2px solid aqua;
                

            }
     
          &:hover {
				/* 鼠标悬浮时盒子出现的阴影 */
                //    box-shadow: 0px 1px 12px 0px #cccccc;
				transform: translate(0, -5px);/* 鼠标悬浮时盒子上移10px */
			}
            p {
                color: #999999;
            }
        }
    }
      .style-con {
            .style-item {
                
                display: flex;
                align-items: center;
                margin-top: 20px;
               
                span {
                    margin-right: 20px;
                    display: inline-block;
                    width: 60px;
                     text-align: right;
                }
                p {
                    margin-left: 4px;
                    color: #999999;
                }
            }
            /deep/.el-checkbox {
                margin-right: 10px;
                color: #999999;
            }
            /deep/.el-checkbox__label {
                padding-left: 4px;
            }
        }
          .tab-chat {
        // position: relative;
        display: flex;
        align-items: center;
        justify-content: space-between;

        span {
            display: inline-block;
            padding: 0px 8px;
            margin-right: 20px;
            color: #999999;
            height: 24px;
            border-bottom: 2px solid transparent;
            &.active{
                color: #359EFF;
                border-bottom-color: #359EFF;
            }
        }
        p {
            margin-right: 20px;
            color: #359EFF;
        }
       
    }
     .direct {
            .data-type {
                margin-top: 20px;
                margin-bottom: 12px;
                span {
                    color: #999999;
                    margin-right: 10px;
                }
            }
           
            
        }
        .line-data-y {
                width: 3.12rem;
                /deep/.el-tree {
                    width: 100%;
                }
                /deep/.el-tree-node {
                    width: 100%;
                }
            }
            /deep/.el-input-number{
                line-height: 34px;
                width: 120px;
            }
            /deep/.el-input-number.is-controls-right .el-input-number__decrease, .el-input-number.is-controls-right .el-input-number__increase{
                line-height: 17px;
            }
            /deep/.el-input__inner {
                height: 36px;
                line-height: 36px;
            }

     .tab-chat {
        // position: relative;
        margin-top: 10px;
        span {
            display: inline-block;
            padding: 0px 8px;
            margin-right: 20px;
            color: #999999;
            height: 24px;
            border-bottom: 2px solid transparent;
            &.active{
                color: #359EFF;
                border-bottom-color: #359EFF;
            }
        }
       
       
    }
    
   



}
</style>